import React from "react";
import World from "../../world";
import ResetPasswordForm from "./View";
import styles from "./ResetPassword.module.scss";

export interface Props {
    world: World;
}

export interface State {
    email: string;
    sent: boolean;
    is_pending: boolean;
    error?: string;
}

export default class ResetPasswordFormController extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            email: "",
            sent: false,
            is_pending: false,
        };
    }

    public handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        switch (e.currentTarget.name) {
        case "email":
            this.setState({
                email: e.currentTarget.value,
            });
            break;
        }
    }

    public handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.setState({
            is_pending: true,
        });
        const err = await this.props.world.resetPassword(this.state.email);
        if (err) {
            this.setState({
                error: err.message,
                is_pending: false,
            });
            return;
        }
        this.setState({
            sent: true,
        });
    }

    render() {
        if (this.state.sent) {
            return (
                <div className={styles.sent}>
                    <h1>Check your email</h1>
                </div>
            );
        }
        const props = {
            onChange: this.handleChange,
            onSubmit: this.handleSubmit,
            is_pending: this.state.is_pending,
            error: this.state.error,
        };

        return (
            <ResetPasswordForm {...props} />
        );
    }
}
